import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CONCEPT_DISABLE, USERDATA } from "../../types";
import Loading from "../../components/Loading";
import { useParams } from "react-router";
import { requests } from "../../axios";
import VoteForm from "../../components/VoteForm";
import { getAssemblyApartmentsRequest } from "../../actions";
import { getStorage } from "../../utils";

const Vote = (props) => {
  const params = useParams();

  const [requestState, setRequestState] = useState({
    loading: true,
    error: null,
  });

  const [voteState, setVoteState] = useState({
    data: null,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      if (!props.assemblyApartments.length) {
        const response = await requests.users.getUsersAssemblyApartments(
          props.user.userId || getStorage(USERDATA).userId,
        );
        props.getAssemblyApartmentsRequest(response.data);
      }
      const response = await requests.joints.getActiveConcept(params.jointId);
      setVoteState({ data: response.data });
      setRequestState({ ...requestState, loading: false });
    } catch (error) {
      console.log(error);
      setRequestState({
        loading: false,
        error: CONCEPT_DISABLE,
      });
    }
  };

  return (
    <>
      {requestState.loading ? (
        <Loading />
      ) : (
        <VoteForm
          voteState={voteState}
          setVoteState={setVoteState}
          requestState={requestState}
          setRequestState={setRequestState}
          redirect={true}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    assemblyApartments: state.assemblyApartments,
  };
};

const mapDispatchToProps = {
  getAssemblyApartmentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Vote);
